import cookie from 'js-cookie'

// 懒得用store了 存对象吧

export default {
  /*
    token 存cookie 要不要存localstorage??
  */
  get token() {
    return cookie.get('mjb-user-token')
  },

  set token(token) {
    cookie.set('mjb-user-token', token, {expires: 1, path: '/'})
  },

  /*
    tel
  */

  tel: null,

  /*
    private int id;//产品Id
    private String name;//名称
    private String desc;//描述文案
    private int tag;//标签(限购等),1:hot
    private int originalPrice;//原价
    private int salePrice;//售价
    private int subscribeMonths;//订阅月数
    private int buyNumLimit;//限购数量
    private String iosProductId;//iOS渠道支付需要的信息,后面小青跟我单独沟通
    private boolean canBuy;//当指定用户手机号或用户ID时,该值表示用户是否有购买该商品的权限
  */

  production: null,

  /*
    private int id;//店铺Id
    private String name;//店铺名称
    private String headFigureUrl = StringUtils.EMPTY;//头图
    private String addressDetail = StringUtils.EMPTY;
    private String shopOwnerName;//店主姓名
    private int permission = 0;//用户(获取该店铺信息的用户)在该店铺的角色
  */
  shop: null,

  /*
    private int id = 0;//支付方式Id
    private String desc;//支付方式描述
  */
  payments: [],
}




// WEBPACK FOOTER //
// ./src/store/index.js